import { create } from 'zustand'
import type { SlideId } from '@/tenant/TenantConfig'

export type ViewMode = 'main' | 'weekly' | 'monthly'

interface ViewState {
  viewMode: ViewMode
  
  slideIndex: number
  
  paused: boolean
  pauseReason: 'celebration' | 'settings' | 'manual' | null
  
  weeklyShownForIsoWeek: string | null
  monthlyShownForMonth: string | null

  setViewMode: (mode: ViewMode) => void
  setSlideIndex: (i: number) => void
  setSlideId: (id: SlideId, slides: SlideId[]) => void
  advanceSlide: (slides: SlideId[]) => void
  pause: (reason: ViewState['pauseReason']) => void
  resume: () => void
  markWeeklyShown: (key: string) => void
  markMonthlyShown: (key: string) => void
}

export const useViewStore = create<ViewState>((set) => ({
  viewMode: 'main',
  slideIndex: 0,
  paused: false,
  pauseReason: null,
  weeklyShownForIsoWeek: null,
  monthlyShownForMonth: null,

  setViewMode(viewMode) {
    set({ viewMode })
  },
  setSlideIndex(slideIndex) {
    set({ slideIndex })
  },
  setSlideId(id, slides) {
    const idx = slides.indexOf(id)
    if (idx >= 0) set({ slideIndex: idx })
  },
  advanceSlide(slides) {
    set((s) => ({ slideIndex: (s.slideIndex + 1) % Math.max(1, slides.length) }))
  },
  pause(reason) {
    set({ paused: true, pauseReason: reason })
  },
  resume() {
    set({ paused: false, pauseReason: null })
  },
  markWeeklyShown(weeklyShownForIsoWeek) {
    set({ weeklyShownForIsoWeek })
  },
  markMonthlyShown(monthlyShownForMonth) {
    set({ monthlyShownForMonth })
  },
}))
